module.exports = __webpack_public_path__ + "static/media/2021-september-article.a73c25f0.jpg";